import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ToastController } from '@ionic/angular';
import { Clipboard } from '@capacitor/clipboard';
import { PaymentLinkService } from '../../services/payment-link.service';

@Component({
    selector: 'app-payment-link-share',
    templateUrl: './payment-link-share.page.html',
    styleUrls: ['./payment-link-share.page.scss'],
    standalone: false
})
export class PaymentLinkSharePage {
  url: string = '';
  valorTotal: number = 0;
  feePercent: number = 4.5;

  constructor(private router: Router, private toastCtrl: ToastController, private paymentLinkService: PaymentLinkService) {
    const state = this.router.getCurrentNavigation()?.extras?.state;
    if (state) {
      this.url = state['url'];
      this.valorTotal = state['valorTotal'];
    }
    this.paymentLinkService.getFeeConfig().subscribe({
      next: (res: any) => {
        if (res?.feePercent != null) this.feePercent = Number(res.feePercent);
        else if (res?.data?.feePercent != null) this.feePercent = Number(res.data.feePercent);
      },
      error: () => { /* keep default */ },
    });
  }

  async shareLink() {
    const text = `Payment link for your trip: $${this.valorTotal}`;
    const nav = navigator as any;
    try {
      if (nav?.share) {
        await nav.share({ title: 'Payment Link', text, url: this.url });
        return;
      }
    } catch (_) {
      // user cancelled or share unavailable — fall through to clipboard
    }
    await Clipboard.write({ string: `${text}\n${this.url}` });
    const toast = await this.toastCtrl.create({
      message: 'Share unavailable — link copied to clipboard.',
      duration: 2500,
      position: 'bottom',
    });
    await toast.present();
  }

  async copyLink() {
    await Clipboard.write({ string: this.url });
    const toast = await this.toastCtrl.create({
      message: 'Link copied!',
      duration: 2000,
      position: 'bottom',
    });
    await toast.present();
  }

  sendSMS() {
    window.open(`sms:?body=${encodeURIComponent(`Payment link: ${this.url}`)}`);
  }
}
